import MinusCircleSVG from "@design-system/ui-icons/vanilla/MinusCircle"
import { createIcon } from "../createIcon"

export const MinusCircleIcon = createIcon(MinusCircleSVG)
